
import { Component, Vue } from 'vue-property-decorator';
import Layout from '@/layouts/Default.vue';
import ListBlock from '@/views/CRUD/ListTab.vue';

import MedicalServiceTypesModule from '@/store/medicalServiceTypes';
import DirectoriesModule from '@/store/directories';

@Component({
    components: {
        Layout,
        ListBlock,
    },
})
export default class MedicalServiceTypesPage extends Vue {
    repository = MedicalServiceTypesModule;

    get tabsNav() {
        return DirectoriesModule.tabsNav;
    }

    get currentTab() {
        return DirectoriesModule.allTabs.medicalServiceTypes.id;
    }
}
